import React from 'react';
import LoginForm from '../components/LoginForm';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function LoginPage({ onAuthSuccess }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      {/* Header with logo and back button */}
      <div className="absolute top-0 left-0 right-0 z-10">
        <div className="flex items-center justify-between p-6 lg:px-8">
          <Link to="/" className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors">
            <ArrowLeftIcon className="h-5 w-5" />
            <span className="text-sm font-medium">Back to Home</span>
          </Link>
          <Link to="/" className="-m-1.5 p-1.5">
            <span className="sr-only">Fashion Buyer</span>
            <img
              className="h-8 w-auto"
              src="/logo192.png"
              alt="Fashion Buyer Logo"
            />
          </Link>
        </div>
      </div>

      {/* Main content */}
      <div className="flex items-center justify-center min-h-screen pt-16">
        <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-md relative overflow-hidden">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-blue-100 to-transparent rounded-full -translate-y-16 translate-x-16"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-purple-100 to-transparent rounded-full translate-y-12 -translate-x-12"></div>
          
          <div className="relative z-10">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold text-gray-900 mb-2">Welcome Back</h1>
              <p className="text-gray-600">Sign in to your Fashion Buyer account</p>
            </div>
            
            <LoginForm onLogin={onAuthSuccess} />
            
            <div className="text-center text-sm mt-6 space-y-2">
              <div>
                Don&apos;t have an account?{' '}
                <Link to="/register" className="text-blue-600 hover:text-blue-700 font-semibold transition-colors">
                  Register here
                </Link>
              </div>
              <div>
                <Link to="/" className="text-gray-500 hover:text-gray-700 text-xs transition-colors">
                  ← Back to Homepage
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
